import React from "react";
import { Broadcast } from "@phosphor-icons/react";

const SIGNAL_LABELS = {
    sixPointer: "⚡ Six-pointer",
    rivalry: "🔥 Rivalry",
    titleRace: "👑 Title race",
    europeRace: "🏆 Europe race",
    relegationBattle: "💀 Relegation",
    bandwagon: "📈 Bandwagon",
    sellOff: "📉 Sell-off",
    hiddenGem: "💎 Hidden gem",
    favouriteOpponent: "🧬 Favourite opponent",
    regressionRisk: "🎯 Regression risk",
    fdrTrap: "🪤 FDR trap",
};

/**
 * Transparent "why was this challenge generated" panel.
 */
export default function DetectedSignals({ signals, humanPrompt }) {
    const active = Object.entries(signals || {}).filter(([, v]) => v);
    if (active.length === 0 && !humanPrompt) return null;
    return (
        <div className="border border-white/10 bg-[#121212] p-3" data-testid="detected-signals-panel">
            <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-white/50 mb-2">
                <Broadcast size={12} weight="fill" />
                Why this challenge was generated
            </div>
            {active.length > 0 && (
                <div className="flex flex-wrap gap-1.5 mb-2">
                    {active.map(([name]) => (
                        <span
                            key={name}
                            className="font-tag text-[10px] font-bold uppercase bg-fa-yellow/10 text-fa-yellow border border-fa-yellow/40 px-1.5 py-0.5 leading-none"
                            data-testid={`signal-${name}`}
                        >
                            {SIGNAL_LABELS[name] || name}
                        </span>
                    ))}
                </div>
            )}
            {humanPrompt && (
                <div className="border-l-2 border-fa-yellow bg-fa-yellow/5 pl-3 py-1.5">
                    <div className="font-mono text-[9px] uppercase tracking-widest text-fa-yellow mb-1">
                        Moderator prompt
                    </div>
                    <div className="font-mono text-[11px] text-white/80 leading-snug italic">
                        “{humanPrompt}”
                    </div>
                </div>
            )}
        </div>
    );
}
